export const buildQuoteShareUrl = (
  urlPath: string,
  options?: { preview?: boolean }
): string => {
  if (!urlPath) return '';

  const baseUrl = (process.env.QUOTE_SHARE_BASE_URL || '').replace(/\/$/, '');
  const path = urlPath.startsWith('/') ? urlPath : `/${urlPath}`;
  const fullUrl = `${baseUrl}${path}`;
  if (!options?.preview) return fullUrl;
  return fullUrl.includes('?')
    ? `${fullUrl}&preview=true`
    : `${fullUrl}?preview=true`;
};
